/**
 * Adds ResizeObserver support and sets the browser support in the "env" store.
 */
export default async ({ store }) => {
  await Promise.all([
    resizeObserverSupport(),
    store.dispatch('env/setBrowserSupport', {
      webGl: detectWebGl(),
    }),
  ]);
};

/**
 * Detects WebGL support.
 * - returns true if a WebGLRenderingContext is found in the browser's <canvas> element
 *
 * @returns {Boolean}
 */
export function detectWebGl() {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  return gl instanceof WebGLRenderingContext;
}

/**
 * Detects if ResizeObserver exists and loads a polyfill if not.
 */
export async function resizeObserverSupport() {
  if (!window.ResizeObserver) {
    const { ResizeObserver } = await import('@juggle/resize-observer');
    window.ResizeObserver = ResizeObserver;
  }
  const patchResizeObserver = (await import('src/services/raf-resize-observer')).default;
  // Replace ResizeObserver with RafResizeObserver
  patchResizeObserver();
}
